"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRetailerServices = exports.getProfilePicture = exports.getPercentage = exports.getNewStatus = exports.getImage = exports.fetchUsers = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _jsBase = require("js-base64");

var _uuid = require("uuid");

var getRetailerServices = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(articleId, category, categoryId, version, Authorization) {
    var _images$values, responseArray, datasheets, descriptions, images;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return Promise.all([_axios.default.post("".concat(process.env.REACT_APP_ARTICLE_DATA_DATASHEET_ENDPOINT, "?idCategory=").concat(categoryId, "&articleId=").concat(articleId, "&version=").concat(version), {}, {
              headers: {
                Authorization: Authorization
              }
            }), _axios.default.get("".concat(process.env.REACT_APP_ARTICLE_DATA_DESCRIPTION_ENDPOINT, "?idCategory=").concat(categoryId, "&articleId=").concat(articleId, "&version=").concat(version), {
              headers: {
                Authorization: Authorization
              }
            }), _axios.default.post("".concat(process.env.REACT_APP_ARTICLE_DATA_IMAGES_ENDPOINT, "?articleId=").concat(articleId, "&version=").concat(version), {
              category: category
            }, {
              headers: {
                Authorization: Authorization
              }
            })]);

          case 3:
            responseArray = _context.sent;
            datasheets = JSON.parse(responseArray[0].data.body).data;
            descriptions = JSON.parse(responseArray[1].data.body).data;
            images = JSON.parse(responseArray[2].data.body).data;
            images.values = images === null || images === void 0 ? void 0 : (_images$values = images.values) === null || _images$values === void 0 ? void 0 : _images$values.map(function (value) {
              var _images$inputs$find;

              value.name = (_images$inputs$find = images.inputs.find(function (e) {
                return e.id === value.image_id;
              })) === null || _images$inputs$find === void 0 ? void 0 : _images$inputs$find.name;
              return getImage(value);
            });
            return _context.abrupt("return", [datasheets, descriptions, images]);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));

  return function getRetailerServices(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

exports.getRetailerServices = getRetailerServices;

var getImage = function getImage(imageGeneral) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 250;

  try {
    var image = imageGeneral;
    var ext = image.src.split(".");
    var uuid = ext[0].split("-");
    return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, image), {}, {
      version: image.id_version,
      ext: ext[ext.length - 1],
      uuid: uuid.reduce(function (prevVal, currVal, idx) {
        if (idx < 2) return "";else return idx === 2 ? currVal : prevVal + "-" + currVal;
      }, "") || (0, _uuid.v4)(),
      srcDB: image.src,
      src: image.image_id ? "https://d24s337exbt5zr.cloudfront.net/" + _jsBase.Base64.encode(JSON.stringify({
        bucket: process.env.REACT_APP_IMAGES_BUCKET,
        key: image.src,
        edits: {
          resize: {
            width: width * 4,
            height: height * 4,
            fit: "contain",
            background: {
              r: 255,
              g: 255,
              b: 255,
              alpha: 1
            }
          }
        }
      })) : image.src
    });
  } catch (err) {
    console.log("err", err);
    return imageGeneral["error"] = err;
  }
};

exports.getImage = getImage;

var getPercentage = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    var params,
        func,
        _args3 = arguments;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            params = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};

            func = /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                var _params$headers$Autho, _params$headers;

                var headers;
                return _regenerator.default.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        headers = {
                          Authorization: (_params$headers$Autho = params === null || params === void 0 ? void 0 : (_params$headers = params.headers) === null || _params$headers === void 0 ? void 0 : _params$headers.Authorization) !== null && _params$headers$Autho !== void 0 ? _params$headers$Autho : sessionStorage.getItem("jwt")
                        };
                        _context2.next = 3;
                        return _axios.default.post(process.env.REACT_APP_VALID_EXPORT_ENDPOINT, {
                          data: params.data
                        }, {
                          headers: headers
                        }).then(function (response) {
                          return [response.data];
                        }).catch(function (err) {
                          return console.log(err, "Errror");
                        });

                      case 3:
                        return _context2.abrupt("return", _context2.sent);

                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function func() {
                return _ref3.apply(this, arguments);
              };
            }();

            _context3.next = 4;
            return func();

          case 4:
            return _context3.abrupt("return", _context3.sent);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getPercentage() {
    return _ref2.apply(this, arguments);
  };
}();

exports.getPercentage = getPercentage;

var getProfilePicture = function getProfilePicture(userId, width, height) {
  try {
    return "https://d24s337exbt5zr.cloudfront.net/" + _jsBase.Base64.encode(JSON.stringify({
      bucket: process.env.REACT_APP_IMAGES_PROFILE_BUCKET,
      key: "id-".concat(userId, "/").concat(userId, ".png"),
      edits: {
        resize: {
          width: width,
          height: height,
          fit: "contain",
          background: {
            r: 255,
            g: 255,
            b: 255,
            alpha: 0
          }
        }
      }
    }));
  } catch (err) {
    console.log("err", err);
    return defaultUpdate;
  }
};

exports.getProfilePicture = getProfilePicture;

var fetchUsers = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(auth) {
    var usersPromises, usersGroups, header, usersResponse;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            usersPromises = [];
            usersGroups = [];
            header = {
              headers: {
                Authorization: auth
              }
            };
            /**
             * 7 will fetch all text specialists
             * 8 will fetch all img specialists
             * 4 will fetch all text facilitators
             * 5 will fetch all img facilitators
             * 6 will fetch all auditors
             */

            usersPromises.push(_axios.default.get("".concat(process.env.REACT_APP_USER_ENDPOINT, "?fetchRole=7"), header), _axios.default.get("".concat(process.env.REACT_APP_USER_ENDPOINT, "?fetchRole=8"), header), _axios.default.get("".concat(process.env.REACT_APP_USER_ENDPOINT, "?fetchRole=4"), header), _axios.default.get("".concat(process.env.REACT_APP_USER_ENDPOINT, "?fetchRole=5"), header), _axios.default.get("".concat(process.env.REACT_APP_USER_ENDPOINT, "?fetchRole=6"), header));
            _context4.next = 6;
            return Promise.all(usersPromises);

          case 6:
            usersResponse = _context4.sent;
            usersResponse.forEach(function (item, i) {
              usersGroups.push(item.data.data);
            });
            return _context4.abrupt("return", usersGroups);

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchUsers(_x6) {
    return _ref4.apply(this, arguments);
  };
}();

exports.fetchUsers = fetchUsers;

var getNewStatus = function getNewStatus(statusArray) {
  var lookupString = "";
  statusArray.forEach(function (element) {
    return lookupString += element + "/";
  });
  if (lookupString.includes("AS")) return "AS";
  if (lookupString.includes("RCA")) return "RCA";
  if (lookupString.includes("RC")) return "RC";
  if (lookupString.includes("RA")) return "RA";
  if (lookupString.includes("RP")) return "RP";
  if (lookupString.includes("ACA")) return "ACA";
  if (lookupString.includes("PA")) return "PA";
  if (lookupString.includes("CA")) return "CA";
  if (lookupString.includes("IE")) return "IE";
  if (lookupString.includes("AC")) return "AC";
  if (lookupString.includes("AA")) return "AA";
  if (lookupString.includes("AP")) return "AP";
  if (lookupString.includes("R")) return "R";
  if (lookupString.includes("NA")) return "NA";
  if (lookupString.includes("Ex")) return "EX";
  return new Error("Status not found");
};

exports.getNewStatus = getNewStatus;